<template>
  <div class="container">
    <h1 v-show="showCloseMsg" style="text-align:center;">請關閉此頁面後，重新掃瞄QRcode</h1>
  </div>
</template>

<script>
import axios from "axios";
let api_url = process.env.VUE_APP_API_URL;
let my_liff_id = process.env.VUE_APP_LIFF_ID;

export default {
  name: "Redirect",
  props: {
    msg: String
  },
  data() {
    return {
      userId: null,
      showCloseMsg: false
    };
  },

  computed: {
 
  },


  created() {
    console.log(window.location)

    let params = new URLSearchParams(window.location.search.substring(1));
    console.log(params)
    let storeCode = params.get("store")
    console.log(storeCode);
    // this.addFriend(storeCode)

 
      console.log('store user_id null')
      this.$liff.init({liffId: my_liff_id})
    .then( () => {
      // success
      const context = this.$liff.getContext();
      console.log(context);
      console.log(context.userId);
      this.userId  = context.userId
      // this.$store.commit("setUserId", context.userId);
      this.addFriend(storeCode);
      
    })
    .catch( (err) => {
      alert('in created')
      console.log(err)
      alert(err)
    })

    

  },
  methods: {
    openExternalPage(targetUrl) {
      console.log("open: " + targetUrl);
      this.$liff.openWindow({
        url: targetUrl,
        external: true
      });
    },
    addFriend(storeCode) {
    //   alert("in s: " + this.$store.state.userId);
      console.log('at addFriend')
      console.log(this.$store.state.userId)
      axios
        .post(api_url + "/add_friend/", {
          user_id: this.userId,
          // user_id: this.$store.state.userId,
          src: storeCode
        })
        .then(response => {
            var tmp = response.data;
            console.log(tmp);
            this.openExternalPage(tmp.target);

        })
        .catch((error) => {
          console.log(error);
          // this.openExternalPage(tmp.target)
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
